(() => {
  const roots = document.querySelectorAll('.ks-rebuild[data-variant-id]');
  roots.forEach((root) => {
    const form = root.querySelector('.ks-rebuild__form');
    if (!form) return;

    // Flavor links navigate between separate products. Carry only campaign attribution
    // and the draft preview ID, never cart, discount, or arbitrary query parameters.
    const sourceParams = new URLSearchParams(window.location.search);
    const flavorParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content', 'fbclid', 'gclid', 'preview_theme_id'];
    root.querySelectorAll('[data-ks-flavor-link]').forEach((link) => {
      const target = new URL(link.getAttribute('href'), window.location.origin);
      flavorParams.forEach((name) => {
        const value = sourceParams.get(name);
        if (value && value.length <= 512 && (name !== 'preview_theme_id' || /^\d+$/.test(value))) target.searchParams.set(name, value);
      });
      link.href = target.pathname + target.search;
    });

    const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    const variantAvailable = root.dataset.available === 'true';
    const currency = root.dataset.currency || 'USD';
    const format = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    const unitPrice = Number(root.dataset.basePrice);
    const onceReady = { 1: true, 2: root.dataset.once2Ready === 'true', 3: root.dataset.once3Ready === 'true' };
    const prices = {
      once: { 1: unitPrice, 2: Number(root.dataset.once2), 3: Number(root.dataset.once3) },
      subscribe: { 1: Number(root.dataset.sub1), 2: Number(root.dataset.sub2), 3: Number(root.dataset.sub3) }
    };
    const onceCodes = { 2: root.dataset.once2Code, 3: root.dataset.once3Code };
    const plans = { 1: root.dataset.plan1, 2: root.dataset.plan2, 3: root.dataset.plan3 };
    const planNames = { 1: root.dataset.planName1, 2: root.dataset.planName2, 3: root.dataset.planName3 };
    const frequencies = { 1: root.dataset.planFrequency1, 2: root.dataset.planFrequency2, 3: root.dataset.planFrequency3 };
    const tubInputs = [...form.querySelectorAll('input[name="ks_tubs"]')];
    const modeInputs = [...root.querySelectorAll('input[name="ks_mode"]')];
    const selectionInputs = [...tubInputs, ...modeInputs];
    const subscribeInput = modeInputs.find((input) => input.value === 'subscribe');
    const onceInput = modeInputs.find((input) => input.value === 'once');
    const subscriptionNote = root.querySelector('[data-subscription-note]');
    const flavorName = root.classList.contains('ks-rebuild--vanilla') ? 'Vanilla' : 'Chocolate';
    const purchaseButton = form.querySelector('.ks-rebuild__purchase-button');
    const sticky = root.querySelector('[data-sticky]');
    const stickyButton = root.querySelector('[data-sticky-button]');
    const offer = root.querySelector('.ks-rebuild__offer');
    const closingOffer = root.querySelector('.ks-rebuild__close');
    const error = form.querySelector('[data-cart-error]');
    const reviewCart = form.querySelector('[data-review-cart]');
    let primaryVisible = false;
    let busy = false;
    let blocked = false;
    let selectionDisabledSnapshot = null;
    let scrollContainer = null;

    function findScrollContainer() {
      for (let ancestor = root.parentElement; ancestor; ancestor = ancestor.parentElement) {
        if (/^(auto|scroll|overlay)$/.test(window.getComputedStyle(ancestor).overflowY)) return ancestor;
      }
      return document.scrollingElement || document.documentElement;
    }

    const selectedMode = () => modeInputs.find((input) => input.checked)?.value || 'once';
    const selectedTubs = () => Number(tubInputs.find((input) => input.checked)?.value) || 1;
    const available = (mode, tubs) => variantAvailable && (mode === 'once'
      ? [1, 2, 3].includes(tubs) && onceReady[tubs] && Number.isFinite(prices.once[tubs]) && prices.once[tubs] > 0
      : Boolean(plans[tubs] && planNames[tubs] && frequencies[tubs] && prices.subscribe[tubs] > 0));

    function lockSelections() {
      selectionDisabledSnapshot = selectionInputs.map((input) => input.disabled);
      selectionInputs.forEach((input) => { input.disabled = true; });
    }

    function restoreSelections() {
      if (!selectionDisabledSnapshot) return;
      selectionInputs.forEach((input, index) => { input.disabled = selectionDisabledSnapshot[index]; });
      selectionDisabledSnapshot = null;
      render();
    }

    function render() {
      const currentMode = selectedMode();
      tubInputs.forEach((input) => { input.disabled = !available(currentMode, Number(input.value)); });
      if (!available(currentMode, selectedTubs())) {
        const fallback = tubInputs.find((input) => input.value === '3' && available(currentMode, 3))
          || tubInputs.find((input) => input.value === '1' && available(currentMode, 1));
        if (fallback) fallback.checked = true;
      }
      const supply = selectedTubs();
      subscribeInput.disabled = ![1, 2, 3].some((quantity) => available('subscribe', quantity));
      subscriptionNote.hidden = !subscribeInput.disabled || !variantAvailable;
      if (subscribeInput.disabled && selectedMode() === 'subscribe') onceInput.checked = true;
      const mode = selectedMode();
      const tubs = supply;
      const total = prices[mode][tubs];
      const label = `${tubs} ${tubs === 1 ? 'tub' : 'tubs'} · ${mode === 'once' ? 'buy once' : 'subscribe'}`;
      const onceTotal = prices.once[tubs];
      const fullTotal = unitPrice * tubs;
      const savings = fullTotal - total;
      const savingsPercent = Math.round(savings / fullTotal * 100);
      const savingsComparison = tubs === 1 ? 'buy once' : `${tubs} separate tubs`;
      const subscriptionAvailable = available('subscribe', tubs);
      root.querySelector('[data-mode-once-price]').textContent = format(onceTotal);
      root.querySelector('[data-mode-subscribe-price]').textContent = subscriptionAvailable ? format(prices.subscribe[tubs]) : subscribeInput.disabled ? 'Unavailable' : 'See options';
      root.querySelector('[data-mode-detail]').textContent = mode === 'once'
        ? `${savings > 0 ? `Save ${format(savings)} (${savingsPercent}%) vs ${savingsComparison}. ` : ''}One charge. No renewal.`
        : `Save ${format(savings)} (${savingsPercent}%) vs ${savingsComparison}. Renews ${frequencies[tubs].replace(/^Deliver\s+/i, '').trim().toLowerCase()} at ${format(prices.subscribe[tubs])}.`;
      [1, 2, 3].forEach((quantity) => {
        const tierInput = tubInputs.find((input) => Number(input.value) === quantity);
        if (tierInput) tierInput.closest('.ks-rebuild__tier').hidden = mode === 'subscribe' && !available('subscribe', quantity);
        const tierTotal = available('subscribe', quantity) && mode === 'subscribe' ? prices.subscribe[quantity] : prices.once[quantity];
        form.querySelector(`[data-tier-total="${quantity}"]`).textContent = format(tierTotal);
        form.querySelector(`[data-tier-per-tub="${quantity}"]`).textContent = `${format(tierTotal / quantity)} per tub${mode === 'subscribe' && available('subscribe', quantity) ? ' · subscribe' : ''}`;
        const tierOriginal = form.querySelector(`[data-tier-original="${quantity}"]`);
        if (tierOriginal) tierOriginal.hidden = !available(mode, quantity) || tierTotal >= unitPrice * quantity;
        const tierSaving = form.querySelector(`[data-tier-saving="${quantity}"]`);
        if (tierSaving) {
          const tierSavings = unitPrice * quantity - tierTotal;
          tierSaving.hidden = tierSavings <= 0 || !available(mode, quantity);
          tierSaving.textContent = tierSavings > 0 ? `Save ${format(tierSavings)}` : '';
        }
      });
      root.querySelector('[data-summary-choice]').textContent = label;
      root.querySelector('[data-summary-price]').textContent = format(total);
      const summarySavings = root.querySelector('[data-summary-savings]');
      summarySavings.hidden = savings <= 0;
      summarySavings.textContent = savings > 0 ? `Save ${format(savings)} (${savingsPercent}%) vs ${savingsComparison}.` : '';
      root.querySelector('[data-summary-terms]').textContent = mode === 'once'
        ? `${tubs * 24} servings. One-time purchase. No recurring charge.`
        : `${tubs * 24} servings. ${format(total)} due today; renews at ${format(total)} ${frequencies[tubs].replace(/^Deliver /, '').toLowerCase()}. Review future charges and cancellation terms at checkout.`;
      form.querySelector('[data-quantity]').value = String(tubs);
      const sellingPlanInput = form.querySelector('[data-selling-plan]');
      sellingPlanInput.disabled = mode !== 'subscribe';
      sellingPlanInput.value = mode === 'subscribe' ? plans[tubs] : '';
      sticky.querySelector('[data-sticky-choice]').textContent = `Rebuild ${flavorName} · ${tubs} ${tubs === 1 ? 'tub' : 'tubs'}`;
      sticky.querySelector('[data-sticky-price]').textContent = mode === 'subscribe'
        ? `Subscribe · ${format(total)} today; renews ${format(total)} ${frequencies[tubs].replace(/^Deliver\s+/i, '').trim().toLowerCase()}`
        : `Buy once · ${format(total)} today; no renewal`;
      if (!busy && !blocked) purchaseButton.textContent = variantAvailable ? `${mode === 'subscribe' ? 'Add subscription' : 'Add to cart'} — ${format(total)} today` : 'Sold out';
      updateSticky();
    }

    function updateSticky() {
      const primaryPassed = purchaseButton.getBoundingClientRect().bottom < 0;
      const scrollThreshold = window.innerWidth >= 750 ? 180 : 240;
      const scrollTop = scrollContainer ? scrollContainer.scrollTop : window.scrollY;
      const pastProduct = root.getBoundingClientRect().bottom <= window.innerHeight * 0.25;
      const closingOfferVisible = closingOffer && closingOffer.getBoundingClientRect().top < window.innerHeight * 0.8;
      stickyButton.textContent = primaryPassed ? (selectedMode() === 'subscribe' ? 'Add subscription' : 'Add to cart') : 'Choose supply';
      sticky.hidden = !variantAvailable || scrollTop < scrollThreshold || primaryVisible || closingOfferVisible || pastProduct || busy || blocked;
    }

    function bindScrollContainer() {
      const nextContainer = findScrollContainer();
      if (nextContainer !== scrollContainer) {
        scrollContainer?.removeEventListener('scroll', updateSticky);
        scrollContainer = nextContainer;
        scrollContainer?.addEventListener('scroll', updateSticky, { passive: true });
      }
      updateSticky();
    }

    selectionInputs.forEach((input) => input.addEventListener('change', () => {
      if (busy || blocked) return;
      error.hidden = true;
      render();
    }));
    const buttonObserver = new IntersectionObserver(([entry]) => { primaryVisible = entry.isIntersecting; updateSticky(); }, { threshold: 0.15 });
    buttonObserver.observe(purchaseButton);
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', bindScrollContainer);
    bindScrollContainer();
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      busy = false;
      blocked = false;
      error.hidden = true;
      error.textContent = '';
      reviewCart.hidden = true;
      purchaseButton.disabled = !variantAvailable;
      restoreSelections();
      render();
    });
    stickyButton.addEventListener('click', () => {
      if (purchaseButton.getBoundingClientRect().bottom < 0) form.requestSubmit(purchaseButton);
      else offer.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });

    const gallery = root.querySelector('[data-gallery]');
    if (gallery) {
      const viewport = gallery.querySelector('[data-gallery-viewport]');
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const count = gallery.querySelector('[data-gallery-count]');
      const names = ['Actual product', 'Official label', 'Illustrative routine', 'Serving facts'];
      let activeIndex = 0;

      function showIndex(index, moveViewport) {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-pressed', String(dotIndex === activeIndex)));
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === slides.length - 1;
        count.textContent = `${activeIndex + 1} of ${slides.length} · ${names[activeIndex]}`;
        if (moveViewport) viewport.scrollTo({ left: viewport.clientWidth * activeIndex, behavior: 'auto' });
      }

      previous.addEventListener('click', () => showIndex(activeIndex - 1, true));
      next.addEventListener('click', () => showIndex(activeIndex + 1, true));
      dots.forEach((dot, index) => dot.addEventListener('click', () => showIndex(index, true)));
      viewport.addEventListener('scroll', () => {
        const index = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
        if (index !== activeIndex) showIndex(index, false);
      }, { passive: true });
      showIndex(0, false);
    }

    async function readCart() {
      const response = await fetch(`${rootPath}cart.js?ks_reconcile=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Could not read cart.');
      return response.json();
    }

    function matchingQuantity(cart, mode, tubs) {
      const wantedPlan = mode === 'subscribe' ? String(plans[tubs]) : '';
      return cart.items.reduce((sum, item) => {
        const itemPlan = item.selling_plan_allocation?.selling_plan?.id;
        const actualPlan = itemPlan == null ? '' : String(itemPlan);
        return Number(item.id) === Number(root.dataset.variantId) && actualPlan === wantedPlan ? sum + Number(item.quantity || 0) : sum;
      }, 0);
    }

    function variantQuantity(cart) {
      return cart.items.reduce((sum, item) => Number(item.id) === Number(root.dataset.variantId) ? sum + Number(item.quantity || 0) : sum, 0);
    }

    function oneTimeVariantTotal(cart) {
      return cart.items.reduce((sum, item) => {
        if (Number(item.id) !== Number(root.dataset.variantId) || item.selling_plan_allocation) return sum;
        return sum + Number(item.final_line_price);
      }, 0);
    }

    function subscriptionVariantTotal(cart, planId) {
      return cart.items.reduce((sum, item) => {
        if (Number(item.id) !== Number(root.dataset.variantId) ||
            String(item.selling_plan_allocation?.selling_plan?.id || '') !== String(planId)) return sum;
        return sum + Number(item.final_line_price);
      }, 0);
    }

    function hasDifferentDiscountCode(cart, bundleCode) {
      return (cart.discount_codes || []).some((entry) =>
        entry && typeof entry.code === 'string' && entry.code.trim() &&
        entry.code.trim().toUpperCase() !== bundleCode.toUpperCase()
      );
    }

    function showIssue(message, mustReviewCart, preflightOnly = false) {
      error.textContent = message;
      error.hidden = false;
      reviewCart.hidden = !mustReviewCart;
      reviewCart.href = `${rootPath}cart`;
      blocked = mustReviewCart && !preflightOnly;
      busy = false;
      if (!blocked) restoreSelections();
      purchaseButton.disabled = blocked;
      purchaseButton.textContent = blocked ? 'Review cart before retrying' : `${selectedMode() === 'subscribe' ? 'Add subscription' : 'Add to cart'} — ${format(prices[selectedMode()][selectedTubs()])} today`;
      updateSticky();
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy || blocked || !variantAvailable) return;
      const mode = selectedMode();
      const tubs = selectedTubs();
      if (!available(mode, tubs)) return;
      busy = true;
      lockSelections();
      error.hidden = true;
      purchaseButton.disabled = true;
      purchaseButton.textContent = 'Adding to cart…';
      updateSticky();
      let beforeCart;
      try {
        beforeCart = await readCart();
      } catch (_) {
        showIssue('Could not confirm your current cart. Please try again after refreshing the page.', false);
        return;
      }
      if (mode === 'once' && tubs > 1) {
        const code = onceCodes[tubs];
        if (!code || !/^[A-Za-z0-9_-]{1,64}$/.test(code)) {
          showIssue('The multi-tub discount could not be verified. Choose another offer or review your cart before checkout.', true, true);
          return;
        }
        if (hasDifferentDiscountCode(beforeCart, code)) {
          showIssue('Your cart already has a discount code. We have not added tubs or changed that code. Choose another offer or review your cart before choosing this multi-tub offer.', true, true);
          return;
        }
      }
      let response;
      let responsePayload = {};
      try {
        const item = { id: Number(root.dataset.variantId), quantity: tubs };
        if (mode === 'subscribe') item.selling_plan = Number(plans[tubs]);
        response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [item] })
        });
        responsePayload = await response.json().catch(() => ({}));
      } catch (_) {
        response = null;
      }
      let afterCart;
      try {
        afterCart = await readCart();
      } catch (_) {
        showIssue('The cart request may have succeeded, but we could not verify it. Review your cart before trying again so you do not add a duplicate.', true);
        return;
      }
      const quantityAdded = matchingQuantity(afterCart, mode, tubs) - matchingQuantity(beforeCart, mode, tubs);
      if (quantityAdded === tubs) {
        if (mode === 'subscribe') {
          const matchingLines = afterCart.items.filter((item) =>
            Number(item.id) === Number(root.dataset.variantId) &&
            String(item.selling_plan_allocation?.selling_plan?.id || '') === String(plans[tubs]));
          const unitCeiling = prices.subscribe[tubs] / tubs;
          const stablePrice = matchingLines.length > 0 && matchingLines.every((item) => {
            const allocation = item.selling_plan_allocation;
            const plan = allocation?.selling_plan;
            const adjustment = plan?.price_adjustments;
            return plan?.recurring_deliveries === true && plan.name === planNames[tubs] &&
              plan.options?.[0]?.value === frequencies[tubs] && adjustment?.length === 1 &&
              adjustment[0].order_count == null && Number(allocation.price) > 0 &&
              Number(allocation.price) === Number(allocation.per_delivery_price) &&
              Number(allocation.per_delivery_price) <= unitCeiling;
          });
          const lineIncrease = subscriptionVariantTotal(afterCart, plans[tubs]) - subscriptionVariantTotal(beforeCart, plans[tubs]);
          const cartIncrease = Number(afterCart.total_price) - Number(beforeCart.total_price);
          const lostExistingCode = (beforeCart.discount_codes || []).some((entry) =>
            entry.applicable && !afterCart.discount_codes?.some((current) =>
              current.code?.toUpperCase() === entry.code?.toUpperCase() && current.applicable));
          if (!stablePrice || lostExistingCode || !Number.isFinite(lineIncrease) ||
              !Number.isFinite(cartIncrease) || lineIncrease > prices.subscribe[tubs] ||
              cartIncrease > prices.subscribe[tubs]) {
            showIssue('The subscription was added, but its cart price or renewal terms need review. Check your cart before checkout.', true);
            return;
          }
        }
        if (mode === 'once' && tubs > 1) {
          const code = onceCodes[tubs];
          if (hasDifferentDiscountCode(afterCart, code)) {
            showIssue('The tubs were added, but your existing discount code was kept. Review your cart before checkout to choose which offer you want.', true);
            return;
          }
          try {
            const previousCodes = (afterCart.discount_codes || []).map((entry) => entry.code).filter(Boolean);
            const combinedCodes = [...new Set([...previousCodes, code])];
            const discountResponse = await fetch(`${rootPath}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ discount: combinedCodes.join(',') })
            });
            if (!discountResponse.ok) throw new Error('Discount route failed.');
            const discountedCart = await readCart();
            const codeApplied = discountedCart.discount_codes?.some((entry) => entry.code?.toUpperCase() === code.toUpperCase() && entry.applicable);
            const lostExistingCode = (afterCart.discount_codes || []).some((entry) => entry.applicable && !discountedCart.discount_codes?.some((current) => current.code?.toUpperCase() === entry.code?.toUpperCase() && current.applicable));
            const actualVariantIncrease = oneTimeVariantTotal(discountedCart) - oneTimeVariantTotal(beforeCart);
            const actualCartIncrease = Number(discountedCart.total_price) - Number(beforeCart.total_price);
            const quantityPreserved = matchingQuantity(discountedCart, mode, tubs) === matchingQuantity(afterCart, mode, tubs);
            if (!codeApplied || lostExistingCode || !quantityPreserved ||
                !Number.isFinite(actualVariantIncrease) || !Number.isFinite(actualCartIncrease) ||
                actualVariantIncrease > prices.once[tubs] || actualCartIncrease > prices.once[tubs]) {
              throw new Error('The added tubs cost more than the displayed offer or affected an existing discount.');
            }
          } catch (_) {
            showIssue(`The ${tubs}-tub offer was added, but the final discount or an existing code needs review. Check your cart price before checkout.`, true);
            return;
          }
        }
        window.location.assign(`${rootPath}cart`);
        return;
      }
      const variantChanged = variantQuantity(afterCart) !== variantQuantity(beforeCart);
      const cartChanged = afterCart.item_count !== beforeCart.item_count;
      if (quantityAdded !== 0 || variantChanged || cartChanged || !response || response.ok) {
        showIssue(`${Math.max(quantityAdded, 0)} of ${tubs} tubs may have been added. Review your cart before trying again.`, true);
        return;
      }
      showIssue(responsePayload.description || responsePayload.message || 'Could not add this offer. Please try again.', false);
    });
    const preferredPack = tubInputs.find((input) => input.value === '3');
    if (preferredPack && available('once', 3)) preferredPack.checked = true;
    render();
  });
})();
